<template lang="pug">
  v-card(
    flat
    :color="filled ? 'ui-background' : undefined"
  )
    v-list-item
      v-list-item-content
        .d-flex.flex-column.gap-4.gr-1
          h3(v-if="label") {{ label }}
      v-list-item-action
        d-switch(
          v-model="inputValue"
          :disabled="disabled"
        )
</template>

<script>
import DSwitch from '../DSwitch.vue';

export default {
  components: {
    DSwitch,
  },
  props: {
    label: {
      type: String,
      default: undefined,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Boolean, Object, String, Array],
      default: undefined,
    },
  },
  data() {
    return {
      inputValue: undefined,
    };
  },
  watch: {
    value: {
      handler(val) {
        this.inputValue = val;
      },
      immediate: true,
    },
    inputValue(val) {
      this.$emit('input', val);
    },
  },
};
</script>
